export default __webpack_public_path__ + "static/media/qqqr.f76b6fbf.png";